import "./style.scss";
import heartIcon from "assets/images/svg/heart-icon.svg";
import Profile from "assets/images/png/connect-profiles.png";
import ConnectCards from "components/Cards/connectCards";

function ConnectSection() {
  return (
    <div className="container">
      <div className="connect-section">
        <div className="title">
          Connecting{" "}
          <span className="connecting-wrapper">
            <img src={Profile} alt="Profile" className="Profile" />
            <img src={heartIcon} alt="heart" className="heart" />
          </span>{" "}
          hearts,
          <br /> Building futures!
        </div>
        <ConnectCards />
      </div>
    </div>
  );
}

export default ConnectSection;
